import PropTypes from 'prop-types';

export default {
  from: PropTypes.string,
  to: PropTypes.string
};
